import login from './login'
import ssoLogin from './login/sso'
import findPwd from './find-pwd'
import users from './users'

const custom = {
  path: '',
  component: resolve => require(['../../pages/custom'], resolve),
  children: [
    login,
    ssoLogin,
    findPwd,
    users
  ]
}

export default custom
